import { colors } from "../../../theme/colors"

export const getColor = (
  color?: "grey" | "blue" | "red" | "yellow" | "black",
) => {
  switch (color) {
    case "yellow":
      return colors.yellow
    case "grey":
      return colors.lightGrey
    case "blue":
      return colors.lightBlue
    case "red":
      return colors.lightRed
    case "black":
      return colors.lightBlack
    default:
      return colors.lightGrey
  }
}
